import { useMonth } from "@datepicker-react/hooks";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { Forward } from "../../assets";
import { useDateCalendarContext } from "./DateCalendarContext";
import { Month } from "./Month";

export const MonthGrid = () => {
  const {
    activeMonths,
    activeMonthIndex,
    isStartMonth,
    isEndMonth,
    firstDayOfWeek,
    goToPreviousMonthsByOneMonth,
    goToNextMonthsByOneMonth,
  } = useDateCalendarContext();

  const { weekdayLabels } = useMonth({
    year: 0,
    month: 0,
    firstDayOfWeek,
  });

  return (
    <Stack
      alignItems={{
        mobile: "center",
        desktop: "stretch",
      }}
      position={{
        desktop: "relative",
      }}
      width={{
        desktop: "696px",
      }}
      height={{
        mobile: "100%",
        desktop: "auto",
      }}
    >
      <Stack
        display={{
          mobile: "flex",
          desktop: "none",
        }}
        alignItems="center"
        width="100%"
        maxWidth="500px"
      >
        <Box
          display="grid"
          gridTemplateColumns="repeat(7, 1fr)"
          justifyItems="center"
          width="100%"
          padding={{
            mobile: 100,
            desktop: 0,
          }}
        >
          {weekdayLabels.map((label) => (
            <Typography
              key={label}
              variant="labelSmallEmphasis"
              color={({ tokens }) => tokens.text.secondary}
            >
              {label}
            </Typography>
          ))}
        </Box>
      </Stack>
      <Stack
        gap={300}
        overflow={{
          mobile: "scroll",
          desktop: "hidden",
        }}
      >
        <Stack
          width={{
            mobile: "100%",
            desktop: "unset",
          }}
          maxWidth={{
            mobile: "500px",
            desktop: "unset",
          }}
          flexDirection={{
            desktop: "row",
          }}
          height={{
            mobile: "100%",
            desktop: "auto",
          }}
          gap={{
            mobile: 300,
            desktop: 500,
          }}
          paddingX={{
            mobile: 200,
            desktop: 0,
          }}
          marginLeft={({ tokens }) => ({
            desktop: `-${activeMonthIndex * (328 + tokens.spacing[500])}px`,
          })}
          sx={({ transitions }) => ({
            transition: `margin-left ${transitions.duration.shorter}ms ${transitions.easing.easeOut}`,
          })}
        >
          {activeMonths.map(({ year, month }) => (
            <Month key={`${year}${month}`} year={year} month={month} />
          ))}
        </Stack>
      </Stack>
      <IconButton
        onClick={goToPreviousMonthsByOneMonth}
        sx={({ tokens }) => ({
          display: {
            mobile: "none",
            desktop: isStartMonth ? "none" : "inline-flex",
          },
          position: "absolute",
          top: tokens.spacing[100] * -1,
          left: tokens.spacing[100] * -1,
          zIndex: 1,
          color: tokens.primary.main,
          transform: "rotate(180deg)",
          padding: 100,
        })}
      >
        <Forward width="16px" height="16px" />
      </IconButton>
      <IconButton
        onClick={goToNextMonthsByOneMonth}
        data-testid="calendar-next-month"
        sx={({ tokens }) => ({
          display: {
            mobile: "none",
            desktop: isEndMonth ? "none" : "inline-flex",
          },
          position: "absolute",
          top: tokens.spacing[100] * -1,
          right: tokens.spacing[100] * -1,
          zIndex: 1,
          color: tokens.primary.main,
          padding: 100,
        })}
      >
        <Forward width="16px" height="16px" />
      </IconButton>
    </Stack>
  );
};
